<div id="wrapper">
    <div class="container-fluid">

    <div class="row">
        <div class="col-lg-4 col-md-4 mx-auto my-card fadeIn">
            <mat-progress-bar mode="indeterminate" *ngIf="flag === true"></mat-progress-bar>
            <div class="text-center" id="resp"></div><br />
         <h3>RESET PASSWORD</h3>
          <form [formGroup]="resetPasscodeForm" (ngSubmit)="resetPasscode(resetPasscodeForm)">
              <mat-form-field>
                  <mat-placeholder>
                      <mat-icon>lock</mat-icon>  New password
                  </mat-placeholder>
                <input matInput type="password" formControlName="npass" name="npass"  id="npass">
                
              </mat-form-field>
              <span class="aler" *ngIf="!resetPasscodeForm.controls['npass'].valid &&
                        resetPasscodeForm.controls['npass'].touched"><small>*Required</small></span>

              <mat-form-field>
                  <mat-placeholder>
                      <mat-icon>lock</mat-icon>  Confirm password
                  </mat-placeholder>
                <input matInput type="password" formControlName="cpass" name="cpass"  id="cpass">
               
              </mat-form-field>
              <p class="aler" *ngIf="!resetPasscodeForm.controls['cpass'].valid &&
              resetPasscodeForm.controls['cpass'].touched"><small>*Required</small></p>
              <p class="aler" *ngIf="resetPasscodeForm.controls['npass'].value != 
              resetPasscodeForm.controls['cpass'].value && 
              (resetPasscodeForm.controls['npass'].touched || resetPasscodeForm.controls['cpass'].touched)">
                <small>Passwords do not match</small></p>
    
              <button type="submit" mat-button id="send" style="outline:none;" [disabled]="!resetPasscodeForm.valid
              || resetPasscodeForm.controls['npass'].value != resetPasscodeForm.controls['cpass'].value"
               class="d-block mx-auto">
                <span>Send</span>
              </button>
              <a routerLink="/login">Login</a>
          </form>
        </div>
      </div>
    </div>
    </div>